import React, { forwardRef } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { focusIndicatorStyles } from '@moonpig/launchpad-components'
import { IconInformation } from '@moonpig/launchpad-assets'

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${s({
    margin: -2,
    padding: '0px 2px 0px 4px',
    color: 'colorTextHeadline',
    borderRadius: 2,
  })}

  &:active {
    ${s({
      color: 'colorInteractionSelectedState',
    })}
  }

  &:not(:disabled) {
    &:hover {
      ${s({
        color: 'colorInteractionIconHover',
      })}
    }
    &:focus {
      ${s({
        color: 'colorInteractionSelectedState',
      })}
    }
  }

  ${focusIndicatorStyles}
`

type Props = {
  ariaLabel: string
  label?: string
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const InfoPillButton = forwardRef<HTMLButtonElement, Props>(
  ({ ariaLabel, onClick }, ref) => {
    return (
      <StyledButton aria-label={ariaLabel} onClick={onClick} ref={ref}>
        <IconInformation height="20px" width="20px" aria-hidden />
      </StyledButton>
    )
  },
)
